<div class="prior-appointment-wrapper py-5">
    <div class="container">
        <h1 class="fw-600 mb-2">{{ (preReservationLabels() ? 'PREAPPOINTMENT.page_title' : 'PRIORAPPOINTMENT.page_title') | translate }}</h1>
        <h3 class="mb-4">{{ (preReservationLabels() ? 'PREAPPOINTMENT.page_subtitle' : 'PRIORAPPOINTMENT.page_subtitle') | translate }}</h3>
        <div class="row">
            <div class="d-flex flex-column flex-md-row">
                <button class="btn bg-white rounded p-3 me-md-4 me-0 mb-4 mb-md-0" (click)="newReservation()">
                    <i class="fa fa-plus-circle me-2"></i><span>{{ (preReservationLabels() ? 'PREAPPOINTMENT.button_new' : 'PRIORAPPOINTMENT.button_new') | translate }}</span>
                </button>

                <button class="btn bg-white rounded p-3 me-md-4 me-0" (click)="newReservation(true)">
                    <i class="fa fa-search me-2"></i><span>{{ (preReservationLabels() ? 'PREAPPOINTMENT.button_view' : 'PRIORAPPOINTMENT.button_view') | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
